import styles from './TermsAndConditions.module.scss'
import {$getLanguage, $t} from '../../../helpers/translator';
import React from 'react';
import api from '../../../helpers/api';
import {Link} from 'react-router-dom';
import {getUser, logout} from "../../../store/auth-slice";
import {useDispatch} from "react-redux";


const TermsAndConditions = (props) => {
    const dispatch = useDispatch();


    const agree = async () => {
        try {
            let res = await api.post('auth/terms/agree');
            if (res && res.success) {
                let user = await dispatch(getUser(true));
            }
        } catch (e) {
            console.error(e)
        }
    }

    const logoutClickHandler = async () => {
        try {
            await dispatch(logout());
        } catch (e) {
            console.error('err logout ', e)
        }
    }

    let lang = $getLanguage() ? $getLanguage() : 'en';

    return (
        <div className={`${styles.pageContainer}`}>
            <div className={`${styles.box}`}>
                <div className={`alma-box ${styles.almaBoxContainer}`}>
                    <div className={'alma-box-header'}>
                        <div>
                            <h3>{$t('global.termsAndConditions.header')}</h3>

                        </div>
                    </div>

                    <div className={`alma-box-content ${styles.contentContainer}`}>
                        {lang === 'en' ?
                            <div>
                                <p>Alma Lasers Ltd. ("<b>Alma Lasers</b>", "<b>us</b>", "<b>our</b>", or "<b>we</b>") is
                                    the owner
                                    of a range of products for aesthetic and medical treatments ("<b>Products</b>"). We
                                    have
                                    developed a dedicated platform related to the use of the Products, which is
                                    available as a
                                    website and mobile application ("<b>Smart Clinic</b>"). These Terms of Service
                                    ("<b>Terms</b>")
                                    govern your access and use of Smart Clinic and services available therein
                                    ("<b>Services</b>").
                                    Our Privacy Notice, available at <Link to="/content/privacy"><b>Privacy
                                        Notice</b></Link> governs
                                    our collection, processing and transfer of any Personal Data (as defined in the
                                    Privacy Notice).
                                </p>
                                <br/>
                                <p>Smart Clinic allows practitioners using our Products ("<b>Practitioner(s)</b>"),
                                    either
                                    independently, as a "<b>Sole Practitioner</b>" or together with other Practitioners
                                    within the
                                    same organization ("<b>Clinic</b>") to collect, save and analyze data, track
                                    progress, and use
                                    other services related to the treatment of patients ("<b>Patients</b>") using the
                                    Products,
                                    including use of the Products and treatment of Patients together with other
                                    Practitioners within
                                    the same Clinic. Smart Clinic also allows distributors of our Products
                                    ("<b>Distributor(s)</b>")
                                    to track the status and use of the Products they have distributed. All as more fully
                                    detailed
                                    below.</p>
                                <br/>
                                <p> read these Terms carefully. By clicking on the button marked "I agree" you signify
                                    your assent
                                    to these Terms. Changes may be made to these Terms from time to time. If you do not
                                    agree to any
                                    of these Terms, please do not click the button marked "I agree" and do not use the
                                    Services.</p>
                                <br/>
                                <p>If you are registering on behalf of a Clinic or accepting these Terms on behalf of a
                                    Distributor,
                                    you represent that you are authorized to enter into, and bind the Clinic or
                                    Distributor, as
                                    applicable, to these Terms and register for Smart Clinic and the Services. You are
                                    solely
                                    responsible for ensuring that these Terms are in compliance with all laws, rules,
                                    and
                                    regulations applicable to you and the Clinic or Distributor, as applicable, and the
                                    right to
                                    access the Smart Clinic is revoked where these Terms or use of the Services is
                                    prohibited.</p>
                                <br/>
                                <h1><u><b>Use of Services</b></u></h1>
                                <br/>
                                <p>Alma Lasers allows you to access and use Smart Clinic and the Services subject to
                                    these Terms.
                                    Alma Lasers may, at its sole discretion and at any time, modify or discontinue
                                    providing the
                                    Services or any part thereof without notice. </p>
                                <br/>
                                <p>Use of and access to the Services is void where prohibited by law. By using the
                                    Services, you
                                    represent and warrant that (a) any and all registration information you submit is
                                    truthful and
                                    accurate; (b) you will maintain the accuracy of such information; (c) you are 18
                                    years of age or
                                    older and have the ability to form a binding contract; (d) your use of the Services
                                    does not
                                    violate any applicable law or regulation or any obligation you may have to a third
                                    party and you
                                    shall comply with applicable law throughout your use of the Smart Clinic and/or
                                    Services; and
                                    (e) if you are Practitioner providing treatment to Patients using the Products, you
                                    have the
                                    necessary licenses, permits, experience and qualifications to do so, under
                                    applicable law.</p>
                                <br/>
                                <h1><u><b>Account Registration - General</b></u></h1>
                                <p>In order to use Smart Clinic and/or the Services, whether as a Practitioner or
                                    Distributor, you
                                    will need to have an account. If you are a Distributor, we will register your
                                    account and give
                                    you access thereto. If you are an Administrator (as defined below) of a Clinic, you
                                    will
                                    register the Clinic's account and will be able to add Practitioners to such Clinic's
                                    account. If
                                    you are a Practitioner using the Services as part of a Clinic, you will be provided
                                    with basic
                                    account details as generated by the Administrator of the Clinic. To complete the
                                    registration
                                    process, you must provide all (additional) registration information as requested by
                                    us. We may
                                    indicate that the provision of some information is optional, but your agreement to
                                    provide such
                                    information may assist us in providing you with improved Services. </p>
                                <br/>
                                <p>You agree to notify us immediately of any unauthorized use of your account or
                                    password. You are
                                    fully and solely responsible for the security of your computer system and/or mobile
                                    device and
                                    all activity on your account, even if such activities were not committed by you.
                                    Alma Lasers
                                    will not be liable for any losses or damage arising from unauthorized use of the
                                    Services, and
                                    you agree to indemnify and hold Alma Lasers harmless for any unauthorized, improper
                                    or illegal
                                    use of your account, and any charges and taxes incurred, unless you have notified us
                                    via e-mail
                                    at info@almalasers.com that your account has been compromised and have requested
                                    that we block
                                    access to it, which we will do as soon as reasonably practicable. We do not police
                                    for and
                                    cannot guarantee that we will learn of or prevent any inappropriate use of the
                                    Services.</p>
                                <br/>
                                <p>Alma Lasers may refuse to open an account for any individual or entity in its sole
                                    discretion.</p>
                                <br/>
                                <h1><u><b>Clinics and Practitioners</b></u></h1>
                                <br/>
                                <p>If you are using the Products either as a (Sole) Practitioner or accepting these
                                    terms as an
                                    Administrator on behalf of a Clinic, the terms below apply to your registration,
                                    collection and
                                    processing of data, in addition to the general terms specified in these Terms.</p>
                                <br/>
                                <h1><u>Registration for a Clinic</u></h1>
                                <br/>
                                <p>An individual designated as the "Administrator" of the Clinic account will be able to
                                    add
                                    Practitioner accounts, which will be connected to the relevant Clinic's account. In
                                    the event
                                    that a single Practitioner is using the Products and Services as part of a Clinic,
                                    such
                                    Practitioner shall be considered the Administrator. The Administrator may configure
                                    the
                                    permissions for each individual Practitioner account. Each additional Practitioner
                                    added by an
                                    Administrator will be required to accept these Terms. </p>
                                <h1><u>Clinic / Sole Practitioner Usage Information</u></h1>
                                <br/>
                                <p>As part of the Services Practitioners, including Sole Practitioners, shall have
                                    access to certain
                                    information relating to their uses of the Products, including but not limited to
                                    charts,
                                    analytics, and other information relating to the number of hours Product(s) are
                                    used,
                                    maintenance and support requirements of the relevant Product(s), and relating to
                                    their Patients'
                                    treatments and progress. Each Practitioner of a Clinic account will have access to
                                    all such
                                    information relating to all Product(s) used by the Clinic and all Patients treated
                                    in the
                                    Clinic.</p>
                                <br/>
                                <h1><u>Management of Personal Data</u></h1>
                                <br/>
                                <p><u>Patient Personal Data</u>: Without derogating from the above, each Practitioner
                                    shall have
                                    access to all Personal Data relating to Patients treated by the Clinic associated
                                    with such
                                    Practitioner's account. Each Sole Practitioner shall have access to all of its
                                    Patient's
                                    Personal Data. When Alma Lasers processes Personal Data of Patients of an individual
                                    Practitioner or a Clinic, both Alma Lasers and the Practitioner and/or the Clinic
                                    will be
                                    considered Controllers of such Personal Data. "<b>Controllers</b>" shall have the
                                    meaning given
                                    to it in the General Data Protection Regulation (EU) 2016/679 of the European
                                    Parliament and of
                                    the Council of 27 April 2016 ("<b>GDPR</b>"). The parties agree to process Personal
                                    Data in
                                    accordance with the Data Sharing Agreement ("<b>DSA</b>") attached hereto as <b>Exhibit
                                        A</b>.
                                </p>
                                <br/>
                                <p>As a Practitioner, you undertake too notify Patients of all information necessary
                                    relating to
                                    collection, processing and transfer of Patient's Personal Data, as required under
                                    applicable
                                    law, including but not limited to the fact that Alma Lasers is a co-Controller of
                                    their Personal
                                    Data and that their Personal Data is processed by Alma Lasers in accordance with the
                                    Privacy
                                    Notice. Such notification shall include a link to the Privacy Notice.</p>
                                <br/>
                                <p>As an Administrator or Sole Practitioner on behalf of a Clinic, you further undertake
                                    as follows:
                                    <br/>
                                    <br/> 1) To obtain and maintain throughout the term of your use of the Services and
                                    for a period
                                    of one year thereafter, all necessary consents as may be required under applicable
                                    law in order
                                    to collect and process Personal Data (including Special Categories of Data (as
                                    defined in the
                                    GDPR)), including its transfer to and use by Alma Lasers in accordance with these
                                    Terms and the
                                    Privacy Notice, including by obtaining consent in respect of each Patient on the
                                    Consent Letter
                                    attached hereto as <b>Exhibit B</b>. In the event that a Patient is under the age of
                                    16
                                    (sixteen), you will obtain the necessary parental consent for collection of any
                                    Personal Data of
                                    such Patient.
                                    <br/> 2) To ensure that a written record of such consents is maintained ("Records"),
                                    as required
                                    under applicable law. You shall maintain such Records at least one year following
                                    termination of
                                    your use of the Services.
                                    <br/> 3) Alma Lasers shall be entitled to audit the Records.
                                    <br/> 4) You have the full right and power to provide Alma Lasers with any Personal
                                    Data,
                                    including name, email address and/or mobile phone number of Practitioners connected
                                    to the
                                    Clinic's account.
                                    <br/> 5) You are fully and solely responsible for providing Alma Lasers with email
                                    addresses
                                    and/or phone numbers only related to Practitioners in your Clinic.
                                    <br/> 6) You shall comply with your obligations as a data Controller, including with
                                    respect to
                                    any specific laws relating to processing of employee data, including, where
                                    applicable, any
                                    relevant Member State law.
                                </p>
                                <br/>
                                <h1><u><b>Distributors</b></u></h1>
                                <br/>
                                <p>If you are a Distributor, you represent and warrant that if you allow others to
                                    access your
                                    account and/or share your username or password with others, including your employees
                                    and service
                                    providers, you will remain fully and solely responsible for the use by such
                                    individuals and
                                    activity on your account. You agree to indemnify and hold Alma Lasers harmless for
                                    any use of
                                    your account. </p>
                                <br/>
                                <h1><u>Distributor Reports</u></h1>
                                <br/>
                                <p>As part of the Services, Distributors shall have access to certain information
                                    relating to the
                                    Products they have distributed, including but not limited to relating to number of
                                    hours used
                                    and maintenance and support requirements of the relevant Product(s). </p>
                                <br/>
                                <h1><u><b>Termination of Account</b></u></h1>
                                <br/>
                                <p>You agree that Alma Lasers may for any reason, in its sole discretion and without
                                    notice,
                                    terminate your account, and may remove from the Services any Content (as defined
                                    below)
                                    associated with your account and take any other corrective action it deems
                                    appropriate. Grounds
                                    for such termination may include (i) extended periods of inactivity, (ii) violation
                                    of the
                                    letter or spirit of these Terms, (iii) fraudulent, harassing or abusive behavior, or
                                    (iv)
                                    behavior that is harmful to other users or the business interests of Alma Lasers. If
                                    your
                                    account is terminated, you may not rejoin Alma Lasers again without our express
                                    permission. Upon
                                    termination of your account, you shall not have any further access to any Content
                                    that may be
                                    available through your account.</p>
                                <br/>
                                <p>We reserve the right to investigate suspected violations of these Terms or illegal
                                    and
                                    inappropriate behavior in connection with the Services. We will fully cooperate with
                                    any law
                                    enforcement authorities or court order requesting or directing us to disclose the
                                    identity,
                                    behavior or Content of anyone believed to have violated these Terms or to have
                                    engaged in
                                    illegal behavior in connection with the Services.</p>
                                <br/>
                                <p>You may request termination of your Alma Lasers account at any time and for any
                                    reason by sending
                                    an email to info@almalasers.com. Following such request, Alma Lasers shall close
                                    your account as
                                    soon as reasonably practicable. Any suspension, cancellation or termination of your
                                    account
                                    shall not affect your obligations under these Terms (including but not limited to
                                    ownership,
                                    indemnification, any representations and warranties made by you, and limitation of
                                    liability),
                                    which by their sense and context are intended to survive such suspension,
                                    cancellation or
                                    termination. If you are an Administrator: (i) you may also request the termination
                                    of the
                                    account of any Practitioner connect to the Clinic account; (ii) it is your
                                    responsibility to
                                    notify us in the event that the employment of Practitioner is terminated, so that we
                                    can ensure
                                    that the Practitioner's account linked to the Clinic is blocked or terminated and
                                    that s/he will
                                    no longer have access to information in connection with such Clinic and
                                    Patients.</p>
                                <br/>
                                <h1><u><b>Content</b></u></h1>
                                <br/>
                                <p>Certain types of content may be made available through the Services. "<b>Content</b>"
                                    as used in
                                    these Terms means, collectively, all content on or made available through the
                                    Services,
                                    including any information, images, photos, pictures, or reports and any
                                    modifications or
                                    derivatives of the foregoing. If you are a Practitioner Alma Lasers allows you to
                                    upload certain
                                    content including but not limited to images and/or pictures on or through Smart
                                    Clinic, referred
                                    to herein as "<b>User Content</b>". </p>
                                <br/>
                                <p>ALMA LASERS DOES NOT ENDORSE ANY CONTENT (INCLUDING WITHOUT LIMITATION ANY USER
                                    CONTENT) OR ANY
                                    OPINION, RECOMMENDATION, OR ADVICE EXPRESSED IN ANY CONTENT AND EXPRESSLY DISCLAIMS
                                    ANY AND ALL
                                    LIABILITY IN CONNECTION WITH THE CONTENT AND/OR USER CONTENT. ALMA LASERS DISCLAIMS
                                    ALL
                                    LIABILITY, REGARDLESS OF THE FORM OF ACTION, FOR THE ACTS OR OMISSIONS OF ANY AND
                                    ALL USERS
                                    (INCLUDING UNAUTHORIZED USERS), WHETHER SUCH ACTS OR OMISSIONS OCCUR DURING THE USE
                                    OF THE
                                    SERVICES OR OTHERWISE.</p>
                                <br/>
                                <h1><u><b>User Content Restrictions</b></u></h1>
                                <br/>
                                <p>Alma Lasers has no obligation to accept, display, or maintain any User Content.
                                    Moreover, Alma
                                    Lasers reserves the right to remove and permanently delete any User Content uploaded
                                    by you,
                                    without notice and for any reason. You are and shall remain at all times fully and
                                    solely
                                    responsible for any User Content you upload to the Smart Clinic. You represent and
                                    warrant that
                                    (i) any User Content you upload complies with applicable law; (ii) any User Content
                                    you upload
                                    does not infringe or violate any third party intellectual property rights, privacy
                                    or publicity
                                    rights, or moral rights; and (iii) you have all necessary rights and authorities to
                                    submit such
                                    User Content. </p>
                                <br/>
                                <p>Without limiting the foregoing, you agree that you will not transmit, submit or
                                    upload any User
                                    Content or act in any way that: (1) restricts of inhibits use of the Services; (2)
                                    violates the
                                    legal rights of others; (3) infringes (or results in the infringement of) the
                                    intellectual
                                    property rights, moral rights, publicity, privacy, or other rights of any third
                                    party; (4) is
                                    (or you reasonably believe or should reasonably believe to be) stolen, illegal,
                                    counterfeit,
                                    fraudulent, pirated, violent or unauthorized, or in furtherance of any illegal,
                                    counterfeiting,
                                    fraudulent, pirating, unauthorized, or violent activity, or that involves (or you
                                    reasonably
                                    believe or should reasonably believe to involve) any stolen, illegal, counterfeit,
                                    fraudulent,
                                    pirated, or unauthorized material; (5) does not comply with all applicable laws,
                                    rules and
                                    regulations; (6) imposes an unreasonably or disproportionately large load on our
                                    infrastructure;
                                    or (7) posts, stores, transmits, offers, or solicits anything that contains the
                                    following, or
                                    that you know contains links to the following or to locations that in turn contain
                                    links to the
                                    following: (a) material that we determine to be inappropriate or offensive (b)
                                    pornography or
                                    obscene material, (c) any virus, worm, trojan horse, or other harmful or disruptive
                                    component or
                                    (d) anything that encourages conduct that would be considered a criminal offense,
                                    give rise to
                                    civil liability, violate any law or regulation. </p>
                                <br/>
                                <h1><u><b>Use Restrictions</b></u></h1>
                                <p>You may not do or attempt to do or facilitate a third party in doing any of the
                                    following: (1)
                                    decipher, decompile, disassemble, or reverse-engineer any of the software and/or
                                    code, if and as
                                    applicable, used to provide the Services without our prior written authorization,
                                    including
                                    framing or mirroring any part of the Services; (2) circumvent, disable, or otherwise
                                    interfere
                                    with security-related features of the Services or features that prevent or restrict
                                    use or
                                    copying of any Content; (3) use the Services or content thereon in connection with
                                    any
                                    commercial endeavors in any manner, except for the purposes specifically set forth
                                    in these
                                    Terms; (4) use any robot, spider, site search or retrieval application, or any other
                                    manual or
                                    automatic device or process to retrieve, index, data-mine, or in any way reproduce
                                    or circumvent
                                    the navigational structure or presentation of the Services; (5) use or access
                                    another user’s
                                    account or password without permission; (6) use the Services or Content in any
                                    manner not
                                    permitted by these Terms.</p>
                                <br/>
                                <h1><u><b>Intellectual Property</b></u></h1>
                                <br/>
                                <p>Alma Lasers or its licensors, as the case may be, have all right, title and interest
                                    in the Smart
                                    Clinic and the Services, and any content thereon, including its overall appearance,
                                    text,
                                    graphics, graphics design, videos, demos, interfaces, and underlying source files,
                                    and all
                                    worldwide intellectual property rights in the Smart Clinic and Services, and the
                                    trademarks,
                                    service marks, and logos contained therein, whether registered and unregistered.
                                    Except as
                                    expressly permitted herein, you may not copy, further develop, reproduce, republish,
                                    modify,
                                    alter download, post, broadcast, transmit or otherwise use the Content for any
                                    purpose. You will
                                    not remove, alter or conceal any copyright, trademark, service mark or other
                                    proprietary rights
                                    notices incorporated in the Services, if any. All trademarks are trademarks or
                                    registered
                                    trademarks of their respective owners. Nothing in these Terms should be construed as
                                    granting
                                    you any right to use any trademark, service mark, logo, or trade name of Alma Lasers
                                    or any
                                    third party. If you provide the Alma Lasers with any feedback regarding any Content
                                    or Services,
                                    Alma Lasers may use all such feedback without restriction and shall not be subject
                                    to any
                                    non-disclosure or non-use obligations in respect of such feedback. </p>
                                <br/>
                                <p>By submitting or uploading any User Content, you grant Alma Lasers and its successors
                                    and
                                    assignees a worldwide, non-exclusive, royalty-free, perpetual, sub-licensable and
                                    transferable
                                    license under any intellectual property, moral or privacy rights to use, copy,
                                    distribute,
                                    transmit, modify, prepare derivative works of such User Content on, through or in
                                    connection
                                    with the Services including without limitation, for improving the Services. </p>
                                <br/>
                                <h1><u><b>Disclaimers and Disclaimer of Warranty</b></u></h1>
                                <br/>
                                <p>All information and Content posted through the Services is for informational purposes
                                    only and
                                    Alma Lasers provides no guarantees with respect thereto. Your use of the Services is
                                    at your
                                    sole discretion and risk. The Services and the Content thereon, are provided on an
                                    AS IS and AS
                                    AVAILABLE basis without warranties of any kind. We do not represent or warrant that
                                    Services
                                    will be of good quality or useful for your needs. </p>
                                <br/>
                                <p>WE EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY,
                                    RELATING TO THE
                                    SERVICES OR CONTENT THEREON, INCLUDING WITHOUT LIMITATION THE WARRANTIES OF TITLE,
                                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT OF PROPRIETARY
                                    RIGHTS,
                                    COURSE OF DEALING OR COURSE OF PERFORMANCE. WE DISCLAIM ANY WARRANTIES, EXPRESS OR
                                    IMPLIED, (I)
                                    REGARDING THE SECURITY, ACCURACY, RELIABILITY, TIMELINESS AND PERFORMANCE OF THE
                                    SERVICES; OR
                                    (II) THAT THE SERVICES WILL BE ERROR-FREE OR THAT ANY ERRORS WILL BE CORRECTED; OR
                                    (III)
                                    REGARDING THE PERFORMANCE OF OR ACCURACY, QUALITY, CURRENCY, COMPLETENESS OR
                                    USEFULNESS OF ANY
                                    INFORMATION PROVIDED BY THE SERVICES. </p>
                                <br/>
                                <p>No advice or information, whether oral or written, obtained by you from us, shall
                                    create any
                                    warranty not expressly stated in these Terms. If you choose to rely on such
                                    information, you do
                                    so solely at your own risk. Some states or jurisdictions do not allow the exclusion
                                    of certain
                                    warranties. Accordingly, some of the above exclusions may not apply to you. Check
                                    your local
                                    laws for any restrictions or limitations regarding the exclusion of implied
                                    warranties.</p>
                                <br/>
                                <p>You acknowledge and agree that Alma Lasers is not a data retention service. You
                                    therefore must
                                    create backups of your data, and Alma Lasers shall have no responsibility or
                                    liability in
                                    respect of any loss of, damage to, or corruption of any such data. </p>
                                <br/>
                                <h1><b>Limitation of Liability</b></h1>
                                <br/>
                                <p>In addition to the foregoing, we assume no responsibility for any error, omission,
                                    interruption,
                                    deletion, defect, delay in operation or transmission, communications line failure,
                                    theft or
                                    destruction or unauthorized access to, or alteration of, any portion of the Content
                                    or Services.
                                    We are not responsible for any problems or technical malfunction of any telephone
                                    network or
                                    lines, computer online systems or equipment, servers or providers, software, failure
                                    of any
                                    email due to technical problems or traffic congestion on the Internet or on the
                                    Services,
                                    including any injury or damage to users or to any person's mobile device or computer
                                    related to
                                    or resulting from use of the Services. Under no circumstances shall we be
                                    responsible for any
                                    loss or damage, including personal injury or death, resulting from use of the
                                    Services, from any
                                    content posted on or through the Services, or from the conduct of any users of the
                                    Services,
                                    whether online or offline. In addition, we assume no responsibility for any
                                    incorrect data,
                                    including Personal Data provided by you or on your behalf and you hereby represent
                                    and warrant
                                    that you are solely responsible for any and all data provided to Alma Lasers,
                                    including any
                                    incorrect data and you shall assume any and all liability for any consequences of
                                    provision of
                                    such incorrect data to us.</p>
                                <br/>
                                <p>IN NO EVENT SHALL WE OR ANY OF OUR OFFICERS, DIRECTORS, EMPLOYEES, ASSIGNEES, OR
                                    AGENTS BE LIABLE
                                    TO YOU OR ANY THIRD PARTY FOR ANY DAMAGES WHATSOEVER, INCLUDING WITHOUT LIMITATION
                                    INDIRECT,
                                    INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES, ARISING OUT OF OR IN
                                    CONNECTION WITH
                                    YOUR USE OF THE SERVICES, INCLUDING BUT NOT LIMITED TO THE QUALITY, ACCURACY, OR
                                    UTILITY OF THE
                                    CONTENT PROVIDED AS PART OF OR THROUGH THE SERVICES, WHETHER THE DAMAGES ARE
                                    FORESEEABLE AND
                                    WHETHER OR NOT WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE
                                    FOREGOING LIMITATION
                                    OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE
                                    JURISDICTION
                                    AND IN NO EVENT SHALL OUR CUMULATIVE LIABILITY TO YOU EXCEED AN AMOUNT OF US$50.</p>
                                <br/>
                                <h1><b>Indemnification</b></h1>
                                <br/>
                                <p>You agree to indemnify, defend, and hold harmless Alma Lasers and its employees,
                                    directors,
                                    officers, subcontractors and agents, against any and all claims, damages, or costs
                                    or expenses
                                    (including court costs and attorneys’ fees) that arise directly or indirectly from:
                                    (a) breach
                                    of these Terms by you or anyone using your computer and/or mobile device, password
                                    (whether
                                    authorized or unauthorized); (b) any claim, loss or damage experienced from your use
                                    or
                                    attempted use of (or inability to use) the Services; (c) your violation of any law
                                    or regulation
                                    or any of your obligations, representations, or warranties hereunder; (d) your
                                    infringement of
                                    any right of any third party; and (e) any other matter for which you are responsible
                                    hereunder
                                    or under applicable law. </p>
                                <br/>
                                <h1><b>Miscellaneous</b></h1>
                                <br/>
                                <p>These Terms shall be governed by the laws of the State of Israel exclusive of its
                                    choice of law
                                    rules, and without regard to the United Nations Convention on the International
                                    Sales of Goods
                                    and the competent courts in Tel Aviv-Jaffa shall have exclusive jurisdiction to hear
                                    any
                                    disputes arising hereunder. In any action to enforce these Terms, the prevailing
                                    party will be
                                    entitled to costs and attorneys’ fees. Any cause of action against Alma Lasers must
                                    be brought
                                    within one (1) year of the date such cause of action arose. In the event that any
                                    provision of
                                    these Terms is held to be unenforceable, such provision shall be replaced with an
                                    enforceable
                                    provision which most closely achieves the effect of the original provision, and the
                                    remaining
                                    terms of these Terms shall remain in full force and effect. Nothing in these Terms
                                    creates any
                                    agency, employment, joint venture, or partnership relationship between you and Alma
                                    Lasers or
                                    enables you to act on behalf of Alma Lasers. Except as may be expressly stated in
                                    these Terms,
                                    these Terms constitute the entire agreement between us and you pertaining to the
                                    subject matter
                                    hereof, and any and all other agreements existing between us relating thereto are
                                    hereby
                                    canceled. We may assign and/or transfer our rights and obligations hereunder to any
                                    third party
                                    without prior notice. You shall not assign and/or transfer any of your rights or
                                    obligations
                                    hereunder, and any assignment in violation of the foregoing shall be void. No waiver
                                    of any
                                    breach or default hereunder shall be deemed to be a waiver of any preceding or
                                    subsequent breach
                                    or default. If we are required to provide notice to you hereunder, we may provide
                                    such notice to
                                    the contact details you provided upon registration.</p>
                                <br/>
                                <br/>
                                <br/>
                                <h1 style={{textAlign: 'center'}}><u><b>Exhibit A</b></u></h1>
                                <br/>
                                <h1 style={{textAlign: 'center'}}><b>Data Sharing Addendum</b></h1>
                                <br/>
                                <p>This Data Sharing Addendum ("<b>Addendum</b>"), entered into by and between the
                                    entity accepting
                                    this DPA ("<b>Customer</b>") and Alma Lasers Ltd. ("<b>Company</b>"), forms an
                                    integral part of
                                    and is subject to the Terms of Service entered into by and between Customer and
                                    Company,
                                    ("<b>Terms</b>") and shall be effective as of the date of acceptance by Customer.
                                    Capitalized
                                    terms not otherwise defined herein shall have the meanings given to them in the
                                    Terms.</p>
                                <br/>
                                <p><b>Whereas</b>, each party serves as a Controller (defined below) with respect to
                                    Personal Data
                                    (defined below) of Customer's Practitioners, Administrators and Patients and;</p>
                                <br/>
                                <p><b>Whereas</b>, the parties wish to set forth the respective responsibilities and
                                    duties toward
                                    one another and toward Data Subjects (defined below) with respect to their position
                                    as
                                    co-Controllers of Personal Data; </p>
                                <br/>
                                <p><b>Now therefore</b>, intending to be legally bound, the parties hereby agree as
                                    follows:</p>
                                <br/>
                                <p>1) <u><b>Definitions</b></u>. In addition to capitalized terms defined elsewhere in
                                    this
                                    Addendum, the following terms shall have the meanings set forth below:</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>1.1) "<b>Applicable Law</b>" means Regulation 2016/679
                                    of the
                                    European Parliament and of the Council of 27 April 2016 on the protection of natural
                                    persons
                                    with regard to the processing of personal data and on the free movement of such data
                                    (General
                                    Data Protection Regulation) ("<b>GDPR</b>"), laws implementing or supplementing the
                                    GDPR and the
                                    relevant laws in the State of Israel.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>1.2) "<b>Controller to Controller Standard Clauses</b>"
                                    means the
                                    standard clauses for the transfer of Personal Data to Controllers established in
                                    third countries
                                    approved by the European Commission from time to time, the approved version of which
                                    in force at
                                    present is that set out in the European Commission's Decision 2004/915/EC of 27
                                    December 2004,
                                    available at:<a href="http://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32004D0915&from=EN" target="_blank"> http://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32004D0915&from=EN</a>
                                </p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>1.3) The terms "<b>Controller</b>", "<b>Data Subject</b>",
                                    "<b>Personal
                                        Data</b>", "<b>Personal Data Breach</b>", "<b>Processor</b>", and
                                    "<b>Processing</b>" shall have
                                    the meanings ascribed to them in the GDPR.</p>
                                <br/>
                                <h1><u><b>2) Relationship Between the Parties.</b></u></h1>
                                <br/>
                                <p style={{marginLeft: '15px'}}>2.1) Customer may provide Company with access to
                                    Personal Data of
                                    its Practitioners, Administrators and/or Patients, in accordance with the Terms and
                                    in
                                    accordance with and subject to Applicable Law, including, where required, consent
                                    from the
                                    Practitioner, Administrator or Patient.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>2.2) The parties agree that each will act as a
                                    Controller with
                                    respect to Personal Data. It is acknowledged that each is a separate, independent
                                    Controller of
                                    the Personal Data disclosed under the Terms. Personal Data disclosed under the Terms
                                    will not be
                                    Processed by the parties as joint Controllers as referred to in Article 26 of the
                                    GDPR. Each
                                    party shall be independently responsible for compliance with its obligations as a
                                    Controller
                                    under Applicable Law.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>2.3) As the party in contact with the Data Subjects, the
                                    Customer
                                    shall ensure that Data Subjects are provided with all information required under
                                    Applicable Law,
                                    including with regard to the source of the Personal Data and how to reach the
                                    relevant
                                    co-Controller, as required under Applicable Law. </p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>2.4) The Controller to Controller Standard Clauses shall
                                    apply if
                                    and to the extent the receiving party Processes the Personal Data in countries
                                    outside of the
                                    European Economic Area that do not provide an adequate level of data protection. The
                                    Controller
                                    to Controller Standard Clauses shall be incorporated herein upon execution of this
                                    Addendum by
                                    the parties. <b>Schedule A</b> to this Addendum shall apply as <u><b>Annex
                                        B</b></u> of the
                                    Controller to Controller Standard Clauses.</p>
                                <br/>
                                <h1><u><b>3) Processing of Personal Data.</b></u></h1>
                                <br/>
                                <p style={{marginLeft: '15px'}}>3.1) Neither party will disclose any Personal Data to
                                    the other
                                    party other than as permitted under the Terms, this Addendum, and under Applicable
                                    Law. </p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>3.2) With respect to Personal Data shared in the context
                                    of the
                                    Terms, each party shall Process such Personal Data (i) in accordance with the terms
                                    of the
                                    Terms, this Addendum and Applicable Law and (ii) for the sole purpose of complying
                                    with its
                                    obligations under the Terms.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>3.3) Each party represents and warrants that it shall
                                    only share
                                    Personal Data with the other party in compliance with Applicable Law and its
                                    obligations under
                                    the Terms and this Addendum. Without derogating from the foregoing, Customer
                                    represents that it
                                    shall not share any Personal Data to Company without obtaining the requisite consent
                                    from Data
                                    Subjects to share such information.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>3.4) Unless otherwise agreed in writing and in advance,
                                    neither
                                    party shall share any Personal Data with the other party that contains any Special
                                    Categories of
                                    Personal Data (in accordance with Article 9 of the GDPR) without having obtained the
                                    required
                                    consents, or (ii) contains Personal Data relating to children under age 16 or any
                                    other age
                                    requiring parental consent, as provided by Applicable Law. </p>
                                <br/>
                                <p>4) <u><b>Security</b></u>. Each party shall implement appropriate technical and
                                    organizational
                                    measures to ensure an appropriate level of security of the Personal Data, including,
                                    as
                                    appropriate and applicable, the measures referred to in Article 32(1) of the GDPR.
                                </p>
                                <br/>
                                <h1><u><b>5) Personal Data Breach. </b></u></h1>
                                <br/>
                                <p style={{marginLeft: '15px'}}>5.1) Each party shall notify the other party without
                                    undue delay
                                    upon becoming aware of a Personal Data Breach. </p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>5.2) In the event of a Personal Data Breach, the parties
                                    shall
                                    cooperate in good faith in connection with the investigation, mitigation, and
                                    remediation of
                                    such Personal Data Breach and for the purpose of complying with each party's
                                    obligations under
                                    Applicable Law.</p>
                                <br/>
                                <p>6) <u><b>Third Party Processors</b></u>. Each party may transfer Personal Data to and
                                    otherwise
                                    interact with third-party data Processors. Each party agrees that if it transfers
                                    Personal Data
                                    or otherwise interacts with a third-party data Processor, it will enter into a
                                    separate
                                    contractual arrangement with each such Processor to ensure compliance with its
                                    obligations under
                                    Applicable Law and hereunder. </p>
                                <br/>
                                <h1>7) <b><u>Data Subject Rights.</u></b></h1>
                                <br/>
                                <p style={{marginLeft: '15px'}}>7.1) Each party shall assist the other party, to the
                                    extent
                                    reasonably requested, to comply with any of such other party's statutory obligations
                                    concerning
                                    requests to exercise Data Subject rights under Applicable Law (e.g., for access,
                                    rectification,
                                    deletion of Personal Data, etc.).</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>7.2) When a Data Subject whose Personal Data is being
                                    Controlled by
                                    both parties submits a written request to either party to inspect his or her
                                    Personal Data, such
                                    party shall: </p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>7.2.1) promptly, inform the other party of such request;
                                    and [Alma:
                                    note this requirement]</p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>7.2.2) provide the Data Subject with other party's name
                                    and address
                                    for further inquiries.</p>
                                <br/>
                                <p>8) <u><b>Retention, Deletion or Return of Personal Data</b></u>. Subject to
                                    Applicable Law, each
                                    party will retain Personal Data only for as long as necessary to satisfy the
                                    purposes for which
                                    it was provided to such party, or to the extent required by Applicable Law.</p>
                                <br/>
                                <p>9) <u><b>Indemnity</b></u>. Notwithstanding anything to the contrary in the Terms,
                                    Customer shall
                                    indemnify and hold Company harmless against all claims, actions, third party claims,
                                    losses,
                                    damages and expenses incurred by Company and arising directly or indirectly out of
                                    or in
                                    connection with a breach of this Addendum and/or Applicable Law by Customer. </p>
                                <br/>
                                <h1>10) <b><u>General Terms.</u></b></h1>
                                <br/>
                                <p style={{marginLeft: '15px'}}>10.1) <b>Termination</b>. This Addendum shall terminate
                                    automatically upon the termination of the Terms, provided however, that each party's
                                    obligations
                                    under this Addendum will apply for so long as such party has access to the other
                                    party's
                                    Personal Data.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>10.2) <b>Governing Law and Jurisdiction.</b></p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>10.2.1) The parties to this Addendum hereby submit to
                                    the choice of
                                    jurisdiction stipulated in the Terms with respect to any disputes or claims
                                    howsoever arising
                                    under this Addendum, including disputes regarding its existence, validity or
                                    termination or the
                                    consequences of its nullity.</p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>10.2.2) This Addendum and all non-contractual or other
                                    obligations
                                    arising out of or in connection with it are governed by the laws of the country or
                                    territory
                                    stipulated for this purpose in the Terms.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}> 10.3) <b>Order of Precedence. </b></p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>10.3.1) Nothing in this Addendum reduces the parties'
                                    obligations
                                    under the Terms in relation to the protection of Personal Data or permits either
                                    party to
                                    Process (or permits the Processing of) Personal Data in a manner that is prohibited
                                    by the
                                    Terms. </p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>In the event of inconsistencies between the provisions
                                    of this
                                    Addendum and any other agreements between the parties, including the Terms and
                                    including (except
                                    where explicitly agreed otherwise in writing, signed on behalf of the parties)
                                    agreements
                                    entered into or purported to be entered into after the date of this Addendum, the
                                    provisions of
                                    this Addendum shall prevail. In the event of inconsistencies between the provisions
                                    of this
                                    Addendum and the Controller to Controller Standard Clauses, the Controller to
                                    Controller
                                    Standard Clauses shall prevail.</p>
                                <br/>
                                <h1 style={{marginLeft: '15px'}}>10.4) <b>Changes in Data Protection Laws.</b></h1>
                                <br/>
                                <p style={{marginLeft: '30px'}}>10.4.1) Either party may, by at least thirty (30)
                                    calendar days'
                                    prior written notice to the other party, request in writing any variations to this
                                    Addendum if
                                    they are required as a result of any change in, or decision of a competent authority
                                    under
                                    Applicable Law in order to allow Personal Data to be Processed (or continue to be
                                    Processed)
                                    without breach of Applicable Law.</p>
                                <br/>
                                <p style={{marginLeft: '30px'}}>10.4.2) If the proposed changes are not acceptable to
                                    the other
                                    party, the parties shall discuss the issue in good faith in order to reach a
                                    solution that is
                                    satisfactory to both parties.</p>
                                <br/>
                                <p style={{marginLeft: '15px'}}>10.5) <b>Severance</b>. Should any provision of this
                                    Addendum be
                                    held invalid or unenforceable, then the remainder of this Addendum shall remain
                                    valid and in
                                    force. The invalid or unenforceable provision shall either be (i) amended as
                                    necessary to ensure
                                    its validity and enforceability, while preserving the parties’ intentions as closely
                                    as possible
                                    or, if this is not possible, (ii) construed in a manner as if the invalid or
                                    unenforceable part
                                    had never been contained herein.</p>
                                <br/>
                                <p>This Addendum is entered into and becomes a binding part of the Terms with effect
                                    from the date
                                    of acceptance hereof. </p>

                            </div>
                            :
                            <div>
                                <p>Alma Lasers Ltd. ("<b>Alma Lasers</b>", "<b>nos</b>", "<b>nuestro(s)</b>",
                                    "<b>nuestra(s)</b>" or
                                    "<b>nosotros</b>") s el propietario de una gama de productos para tratamientos
                                    estéticos y
                                    médicos ("<b>Productos</b>"). Hemos desarrollado una plataforma dedicada relacionada
                                    con el uso
                                    de los Productos, que está disponible como sitio web y aplicación móvil ("<b>Smart
                                        Clinic</b>").
                                    Estos Términos de servicio ("<b>Términos</b>") rigen su acceso y uso de Smart Clinic
                                    y los
                                    servicios disponibles allí ("<b>Servicios</b>"). Nuestro Aviso de privacidad,
                                    disponible
                                    en <Link to="/content/privacy"><b>Aviso de privacidad</b></Link> rige nuestra
                                    recopilación,
                                    procesamiento y transferencia de cualquier Información personal (como se define en
                                    el Aviso de
                                    privacidad). </p>
                                <br/>
                                <p>Smart Clinic permite a los médicos que utilizan nuestros Productos ("<b>Médico[s]</b>"),
                                    ya sea
                                    de forma independiente, como "<b>Médico individual</b>" o junto con otros Médicos
                                    dentro de la
                                    misma organización ("<b>Clínica</b>") recopilar, guardar y analizar datos, realizar
                                    un
                                    seguimiento del progreso, y utilizar otros servicios relacionados con el tratamiento
                                    de los
                                    pacientes ("<b>Pacientes</b>") que utilizan los Productos, incluido el uso de los
                                    Productos y el
                                    tratamiento de los pacientes junto con otros Médicos dentro de la misma clínica.
                                    Smart Clinic
                                    también permite a los distribuidores de nuestros Productos ("<b>Distribuidor[es]</b>")
                                    controlar
                                    el estado y el uso de los Productos que han distribuido. Todo como se detalla a
                                    continuación.
                                </p>
                                <br/>
                                <p> Lea estos Términos detenidamente. Al hacer clic en el botón "Acepto", usted expresa
                                    su
                                    aceptación de estos Términos. Se pueden modificar estos Términos de vez en cuando.
                                    Si no está de
                                    acuerdo con alguno de estos Términos, no haga clic en el botón "Acepto" y no use los
                                    Servicios.</p>
                                <br/>
                                <p>Si se registra en nombre de una Clínica o acepta estos Términos en nombre de un
                                    Distribuidor,
                                    declara que está autorizado a ingresar y vincular a la Clínica o al Distribuidor,
                                    según
                                    corresponda, a estos Términos, y registrarse para Smart Clinic y los Servicios.
                                    Usted es el
                                    único responsable de garantizar que estos Términos cumplan con todas las leyes,
                                    reglas y
                                    regulaciones aplicables a usted y a la Clínica o al Distribuidor, según corresponda,
                                    y el
                                    derecho de acceso a Smart Clinic se revoca cuando se prohíban estos Términos o el
                                    uso de los
                                    Servicios.</p>
                                <br/>
                                <h1><u><b>Uso de los Servicios</b></u></h1>
                                <br/>
                                <p>Alma Lasers le permite acceder y utilizar Smart Clinic y los Servicios sujetos a
                                    estos Términos.
                                    Alma Lasers puede, a su exclusivo criterio y en cualquier momento, modificar o
                                    suspender la
                                    prestación de los Servicios o cualquier parte de los mismos sin previo aviso. </p>
                                <br/>
                                <p>El uso y acceso a los Servicios es nulo cuando lo prohíba la ley. Al utilizar los
                                    Servicios,
                                    usted declara y garantiza lo siguiente: (a) toda la información de registro que
                                    envía es veraz y
                                    precisa; (b) mantendrá la precisión de dicha información; (c) tiene 18 años de edad
                                    o más y
                                    tiene la capacidad de celebrar un contrato vinculante; (d) su uso de los Servicios
                                    no viola
                                    ninguna ley o regulación aplicable ni cualquier obligación que pueda tener con un
                                    tercero y
                                    deberá cumplir con la ley aplicable durante el uso de Smart Clinic o los Servicios;
                                    y (e) si
                                    usted es un Médico que brinda tratamiento a Pacientes que usan los Productos, tiene
                                    las
                                    licencias, permisos, experiencia y calificaciones necesarias para hacerlo, según la
                                    ley
                                    aplicable.</p>
                                <br/>
                                <h1><u><b>Registro de cuenta: General</b></u></h1>
                                <p>Para utilizar Smart Clinic o los Servicios, ya sea como Médico o Distribuidor,
                                    necesitará tener
                                    una cuenta. Si es Distribuidor, registraremos su cuenta y le daremos acceso a ella.
                                    Si es
                                    Administrador (como se define más adelante) de una Clínica, registrará la cuenta de
                                    la Clínica y
                                    podrá agregar Médicos a la cuenta de dicha Clínica. Si usted es un Médico que
                                    utiliza los
                                    Servicios como parte de una Clínica, se le proporcionarán los detalles básicos de la
                                    cuenta
                                    generados por el Administrador de la Clínica. PaTel Aviv-Yafora completar el proceso
                                    de
                                    registro, debe proporcionar toda la información de registro (adicional) que le
                                    solicitemos.
                                    Podemos indicar que brindar cierta información es opcional, pero su aceptación de
                                    proporcionar
                                    dicha información puede ayudarnos a proporcionarle mejores Servicios. </p>
                                <br/>
                                <p>Usted acepta notificarnos de inmediato sobre cualquier uso no autorizado de su cuenta
                                    o
                                    contraseña. Usted es total y exclusivamente responsable de la seguridad de su
                                    sistema
                                    informático o dispositivo móvil y de toda la actividad en su cuenta, incluso si
                                    usted no realiza
                                    dichas actividades. Alma Lasers no será responsable de ninguna pérdida o daño que
                                    surja del uso
                                    no autorizado de los Servicios, y usted acepta indemnizar y eximir de
                                    responsabilidad a Alma
                                    Lasers por cualquier uso no autorizado, indebido o ilegal de su cuenta y los cargos
                                    e impuestos
                                    incurridos, a menos que usted nos notifique por correo electrónico a
                                    info@almalasers.com que su
                                    cuenta ha sido comprometida y solicite que bloqueemos el acceso a ella, lo que
                                    haremos tan
                                    pronto como sea razonablemente posible. No vigilamos y no podemos garantizar que
                                    conoceremos o
                                    evitaremos el uso indebido de los Servicios.</p>
                                <br/>
                                <p>Alma Lasers puede negarse a abrir una cuenta para cualquier persona o entidad a su
                                    exclusivo
                                    criterio.</p>
                                <br/>
                                <h1><u><b>Clínicas y Médicos</b></u></h1>
                                <br/>
                                <p>Si está utilizando los Productos como Médico (individual) o acepta estos términos
                                    como
                                    Administrador en nombre de una Clínica, los siguientes términos se aplican a su
                                    registro,
                                    recopilación y procesamiento de datos, además de los términos generales
                                    especificados en estos
                                    Términos.</p>
                                <br/>
                                <h1><u>Registro para una Clínica</u></h1>
                                <br/>
                                <p>Una persona designada como "Administrador" de la cuenta de la Clínica podrá agregar
                                    cuentas de
                                    Médicos, que se conectarán a la cuenta de la Clínica correspondiente. En el caso de
                                    que un
                                    Médico individual esté utilizando los Productos y Servicios como parte de una
                                    Clínica, dicho
                                    Médico se considerará el Administrador. El Administrador puede configurar los
                                    permisos para cada
                                    cuenta de Médico individual. Se requerirá que cada Médico adicional que agregue el
                                    Administrador
                                    acepte estos Términos. </p>
                                <h1><u>Información de uso de la Clínica/el Médico individual</u></h1>
                                <br/>
                                <p>Como parte de los Servicios, los Médicos, incluidos los Médicos individuales, tendrán
                                    acceso a
                                    cierta información relacionada con sus usos de los Productos, incluidos, entre
                                    otros, gráficos,
                                    análisis y otra información relacionada con la cantidad de horas que se utilizan los
                                    Productos,
                                    requisitos de mantenimiento y soporte de los Productos relevantes, y los
                                    tratamientos y el
                                    progreso de sus Pacientes. Cada Médico de una cuenta de la Clínica tendrá acceso a
                                    toda la
                                    información relacionada con todos los Productos utilizados por la Clínica y todos
                                    los Pacientes
                                    tratados en la Clínica.</p>
                                <br/>
                                <h1><u>Administración de la Información personal</u></h1>
                                <br/>
                                <p><u>Información personal del Paciente</u>: sin perjuicio de lo indicado, cada Médico
                                    tendrá acceso
                                    a toda la Información personal relacionada con los Pacientes tratados por la Clínica
                                    asociada
                                    con la cuenta de dicho Médico. Cada Médico individual tendrá acceso a toda la
                                    Información
                                    personal de su Paciente. Cuando Alma Lasers procesa Información personal de
                                    Pacientes de un
                                    Médico individual o una Clínica, tanto Alma Lasers como el Médico o la Clínica serán
                                    considerados Controladores de dicha Información personal. "<b>Controladores</b>"
                                    tendrá el
                                    significado que se le da en el Reglamento General de Protección de Datos (UE)
                                    2016/679 del
                                    Parlamento Europeo y del Consejo de 27 de abril de 2016 ("<b>RGPD</b>"). Las partes
                                    acuerdan
                                    procesar la Información personal de acuerdo con el Acuerdo de intercambio de datos
                                    (Data Sharing
                                    Agreement ("<b>DSA</b>") disponible en [AGREGAR URL]. . </p>
                                <br/>
                                <p>Como Médico, usted también se compromete a notificar a los Pacientes toda la
                                    información
                                    necesaria relacionada con la recopilación, el procesamiento y la transferencia de la
                                    Información
                                    personal del Paciente, según lo exige la ley aplicable, incluido, entre otros, el
                                    hecho de que
                                    Alma Lasers es un Controlador conjunto de su Información personal y que su
                                    Información personal
                                    será procesada por Alma Lasers de acuerdo con el Aviso de privacidad. Dicha
                                    notificación
                                    incluirá un enlace al Aviso de privacidad.</p>
                                <br/>
                                <p>Como Administrador o Médico individual en nombre de una Clínica, usted se compromete
                                    a realizar
                                    lo siguiente:
                                    <br/>
                                    <br/> 1) Obtener y mantener durante todo el período de uso de los Servicios y
                                    durante un período
                                    de un año a partir de entonces todos los consentimientos necesarios según lo
                                    requiera la ley
                                    aplicable para recopilar y procesar la Información personal (incluidas las
                                    Categorías especiales
                                    de datos [como se define en el RGPD]), incluida su transferencia y uso por parte de
                                    Alma Lasers
                                    de acuerdo con estos Términos y el Aviso de Privacidad, incluso la obtención del
                                    consentimiento
                                    con respecto a cada Paciente en la Carta de consentimiento adjunta al presente
                                    como <b>Anexo
                                        A</b>. En el caso de que un Paciente sea menor de 16 (dieciséis) años, usted
                                    obtendrá el
                                    consentimiento necesario de los padres para la recopilación de la Información
                                    personal de dicho
                                    Paciente.
                                    <br/> 2) Garantizar que se mantenga un registro escrito de dichos consentimientos
                                    ("<b>Registros</b>"), según lo exija la ley aplicable. Usted deberá mantener dichos
                                    registros al
                                    menos un año después de la finalización de su uso de los Servicios.
                                    <br/> 3) Alma Lasers tendrá derecho a auditar los Registros.
                                    <br/> 4) Usted tiene todo el derecho y el poder de proporcionar a Alma Lasers
                                    cualquier
                                    Información personal, incluso el nombre, la dirección de correo electrónico o el
                                    número de
                                    teléfono móvil de los Médicos conectados a la cuenta de la Clínica.
                                    <br/> 5) Usted es total y exclusivamente responsable de proporcionar a Alma Lasers
                                    direcciones
                                    de correo electrónico o números de teléfono solo relacionados con los Médicos en su
                                    Clínica.
                                    <br/> 6) Deberá cumplir con sus obligaciones como Controlador de datos, incluso con
                                    respecto a
                                    las leyes específicas relacionadas con el procesamiento de datos de los empleados,
                                    incluida, si
                                    corresponde, cualquier ley pertinente de Estado miembro.
                                </p>
                                <br/>
                                <h1><u><b>Distribuidores</b></u></h1>
                                <br/>
                                <p>Si usted es Distribuidor, declara y garantiza que, si permite que otros accedan a su
                                    cuenta o
                                    comparte su nombre de usuario o contraseña con otros, incluidos sus empleados y
                                    proveedores de
                                    servicios, seguirá siendo total y exclusivamente responsable del uso por parte de
                                    dichas
                                    personas y la actividad en su cuenta. Usted acepta indemnizar y eximir de
                                    responsabilidad a Alma
                                    Lasers por cualquier uso de su cuenta. </p>
                                <br/>
                                <h1><u>Informes del Distribuidor</u></h1>
                                <br/>
                                <p>Como parte de los Servicios, los Distribuidores tendrán acceso a cierta información
                                    relacionada
                                    con los Productos que han distribuido, incluso, entre otros, la cantidad de horas
                                    utilizadas y
                                    los requisitos de mantenimiento y soporte de los Productos relevantes. </p>
                                <br/>
                                <h1><u><b>Cancelación de la cuenta</b></u></h1>
                                <br/>
                                <p>Usted acepta que Alma Lasers, por cualquier motivo, a su sola discreción y sin previo
                                    aviso,
                                    puede cancelar su cuenta, puede eliminar de los Servicios cualquier Contenido (como
                                    se define
                                    más adelante) asociado con su cuenta y puede tomar cualquier otra medida correctiva
                                    que
                                    considere adecuada. Los motivos para dicha cancelación pueden incluir: (i) períodos
                                    prolongados
                                    de inactividad; (ii) violación de la letra o espíritu de estos Términos; (iii)
                                    comportamiento
                                    fraudulento, acosador o abusivo; o (iv) comportamiento que es perjudicial para otros
                                    usuarios o
                                    los intereses comerciales de Alma Lasers. Si su cuenta se cancela, no puede volver a
                                    unirse a
                                    Alma Lasers sin nuestro permiso expreso. Al cancelarse su cuenta, no tendrá más
                                    acceso a ningún
                                    Contenido que pueda estar disponible a través de su cuenta.</p>
                                <br/>
                                <p>Nos reservamos el derecho de investigar presuntas violaciones de estos Términos o
                                    comportamientos
                                    ilegales e inapropiados en relación con los Servicios. Cooperaremos plenamente con
                                    cualquier
                                    autoridad policial u orden judicial que nos solicite o nos ordene divulgar la
                                    identidad, el
                                    comportamiento o el Contenido de cualquier persona que se considere que ha violado
                                    estos
                                    Términos o que ha tenido un comportamiento ilegal en relación con los Servicios.</p>
                                <br/>
                                <p>Puede solicitar la cancelación de su cuenta de Alma Lasers en cualquier momento y por
                                    cualquier
                                    motivo si envía un correo electrónico a info@almalasers.com. Luego de dicha
                                    solicitud, Alma
                                    Lasers cerrará su cuenta tan pronto como sea razonablemente posible. Cualquier
                                    suspensión,
                                    cancelación o baja de su cuenta no afectará sus obligaciones en virtud de estos
                                    Términos
                                    (incluso, entre otros, la propiedad, indemnización, cualquier declaración y garantía
                                    hecha por
                                    usted, y limitación de responsabilidad), que por su sentido y contexto están
                                    destinadas a
                                    sobrevivir a tal suspensión, cancelación o baja. Si usted es Administrador: (i)
                                    también puede
                                    solicitar la cancelación de la cuenta de cualquier Médico conectado a la cuenta de
                                    la Clínica;
                                    (ii) es su responsabilidad notificarnos en caso de que finalice el empleo del
                                    Médico, de modo
                                    que podamos asegurarnos de que la cuenta del Médico vinculada a la Clínica se
                                    bloquee o cancele
                                    y que deje de tener acceso a la información en relación con dicha Clínica y los
                                    Pacientes.</p>
                                <br/>
                                <h1><u><b>Contenido</b></u></h1>
                                <br/>
                                <p>Ciertos tipos de contenido pueden estar disponibles a través de los Servicios.
                                    "<b>Contenido</b>",
                                    tal como se utiliza en estos Términos, significa, colectivamente, todo el contenido
                                    disponible
                                    en los Servicios, incluida cualquier información, imágenes, fotos o informes y
                                    cualquier
                                    modificación o producto derivado de lo anterior. Si usted es Médico, Alma Lasers le
                                    permite
                                    cargar cierto contenido, que incluye, entre otros, imágenes o fotografías, a través
                                    de Smart
                                    Clinic, lo que se denominará en este documento "<b>Contenido del usuario</b>". </p>
                                <br/>
                                <p>ALMA LASERS NO AVALA NINGÚN CONTENIDO (INCLUSO, ENTRE OTROS, CUALQUIER CONTENIDO DEL
                                    USUARIO) O
                                    CUALQUIER OPINIÓN, RECOMENDACIÓN O ASESORAMIENTO EXPRESADO EN EL CONTENIDO Y RECHAZA
                                    EXPRESAMENTE CUALQUIER RESPONSABILIDAD EN RELACIÓN CON EL CONTENIDO O EL CONTENIDO
                                    DEL USUARIO.
                                    ALMA LASERS RECHAZA TODA RESPONSABILIDAD, SIN IMPORTAR LA FORMA DE ACCIÓN, POR LOS
                                    ACTOS U
                                    OMISIONES DE LOS USUARIOS (INCLUIDOS LOS USUARIOS NO AUTORIZADOS), YA SEA QUE DICHAS
                                    ACCIONES U
                                    OMISIONES OCURRAN DURANTE EL USO DE LOS SERVICIOS O DE OTRO MODO.</p>
                                <br/>
                                <h1><u><b>Restricciones del Contenido del usuario</b></u></h1>
                                <br/>
                                <p>Alma Lasers no tiene la obligación de aceptar, mostrar ni mantener el Contenido del
                                    usuario.
                                    Además, Alma Lasers se reserva el derecho de retirar y eliminar permanentemente
                                    cualquier
                                    Contenido del usuario que usted cargue, sin previo aviso y por cualquier motivo.
                                    Usted es y
                                    seguirá siendo en todo momento total y exclusivamente responsable de cualquier
                                    Contenido del
                                    usuario que cargue en Smart Clinic. Usted declara y garantiza lo siguiente: (i)
                                    cualquier
                                    Contenido del usuario que cargue cumple con la ley aplicable; (ii) cualquier
                                    Contenido del
                                    usuario que cargue no infringe ni viola los derechos de propiedad intelectual,
                                    privacidad o
                                    publicidad, o derechos morales de terceros; y (iii) usted tiene todos los derechos y
                                    facultades
                                    necesarios para enviar dicho Contenido del usuario. </p>
                                <br/>
                                <p>Sin perjuicio de lo anterior, usted acepta que no transmitirá, enviará ni cargará
                                    ningún
                                    Contenido del usuario, ni actuará de un modo que: (1) restrinja o inhiba el uso de
                                    los
                                    Servicios; (2) viole los derechos legales de otros; (3) infrinja (o genere la
                                    infracción de) los
                                    derechos de propiedad intelectual, derechos morales, publicidad, privacidad u otros
                                    derechos de
                                    terceros; (4) sea (o usted cree o debería razonablemente creer que es) robado,
                                    ilegal,
                                    falsificado, fraudulento, pirateado, violento o no autorizado, o en apoyo de
                                    cualquier actividad
                                    ilegal, de falsificación, fraudulenta, pirateada, no autorizada o violenta, o que
                                    involucre (o
                                    usted cree razonablemente o debería creer razonablemente que involucra) cualquier
                                    material
                                    robado, ilegal, falsificado, fraudulento, pirateado o no autorizado; (5) no cumpla
                                    con todas las
                                    leyes, normas y reglamentos aplicables; (6) imponga una carga irracional o
                                    desproporcionadamente
                                    grande en nuestra infraestructura; o (7) publique, almacene, transmita, ofrezca o
                                    solicite
                                    cualquier cosa que contenga lo siguiente, o que usted sepa que contiene enlaces a lo
                                    siguiente o
                                    a ubicaciones que a su vez contienen enlaces a lo siguiente: (a) material que
                                    determinamos que
                                    es inapropiado u ofensivo; (b) pornografía o material obsceno; (c) cualquier virus,
                                    gusano,
                                    troyano u otro componente dañino o perjudicial; o (d) cualquier cosa que fomente una
                                    conducta
                                    que se consideraría un delito penal, dará lugar a responsabilidad civil, y violará
                                    cualquier ley
                                    o regulación. </p>
                                <br/>
                                <h1><u><b>Restricciones de uso</b></u></h1>
                                <p>No puede hacer, intentar hacer ni facilitar a un tercero que realice cualquiera de
                                    las siguientes
                                    acciones: (1) descifrar, descompilar, desensamblar o aplicar ingeniería inversa a
                                    cualquiera de
                                    los programas o códigos, según corresponda, utilizados para proporcionar los
                                    Servicios sin
                                    nuestra autorización previa por escrito, lo que incluye enmarcar o reflejar
                                    cualquier parte de
                                    los Servicios; (2) eludir, deshabilitar o interferir de otro modo con las funciones
                                    relacionadas
                                    con la seguridad de los Servicios o las funciones que impiden o restringen el uso o
                                    la copia de
                                    cualquier Contenido; (3) utilizar los Servicios o el contenido de los mismos en
                                    relación con
                                    cualquier actividad comercial de cualquier manera, excepto para los fines
                                    específicamente
                                    establecidos en estos Términos; (4) usar cualquier robot, araña, aplicación de
                                    búsqueda o
                                    recuperación de sitios, o cualquier otro dispositivo o proceso manual o automático
                                    para
                                    recuperar, indexar, extraer datos o de alguna manera reproducir o eludir la
                                    estructura de
                                    navegación o la presentación de los Servicios; (5) usar o acceder a la cuenta o
                                    contraseña de
                                    otro usuario sin permiso; (6) usar los Servicios o el Contenido de cualquier manera
                                    no permitida
                                    por estos Términos.</p>
                                <br/>
                                <h1><u><b>Propiedad intelectual</b></u></h1>
                                <br/>
                                <p>Alma Lasers o sus licenciantes, según sea el caso, tienen todos los derechos, títulos
                                    e intereses
                                    en Smart Clinic y los Servicios, y cualquier contenido de estos, incluso su
                                    apariencia general,
                                    texto, gráficos, diseño gráfico, videos, demostraciones, interfaces y archivos
                                    fuente
                                    subyacentes, y todos los derechos de propiedad intelectual en todo el mundo sobre
                                    Smart Clinic y
                                    los Servicios, y las marcas comerciales, marcas de servicio y logotipos contenidos
                                    en estos, ya
                                    sean registrados o no. Excepto por lo expresamente permitido en este documento,
                                    usted no puede
                                    copiar, desarrollar, reproducir, volver a publicar, modificar, alterar, descargar,
                                    publicar,
                                    transmitir, difundir ni usar de otro modo el Contenido para ningún propósito. No
                                    eliminará,
                                    alterará ni ocultará ningún aviso de derechos de autor, marca registrada, marca de
                                    servicio u
                                    otros avisos de derechos de propiedad incorporados en los Servicios, si corresponde.
                                    Todas las
                                    marcas comerciales son marcas comerciales o marcas comerciales registradas de sus
                                    respectivos
                                    propietarios. Ningún elemento en estos Términos debe interpretarse como una
                                    concesión a usted de
                                    cualquier derecho de uso de una marca comercial, marca de servicio, logotipo o
                                    nombre comercial
                                    de Alma Lasers o de un tercero.Si proporciona a Alma Lasers comentarios sobre
                                    cualquier
                                    Contenido o Servicios, Alma Lasers puede usar todos esos comentarios sin
                                    restricciones y no
                                    estará sujeto a ninguna obligación de no divulgación o no uso con respecto a dichos
                                    comentarios. </p>
                                <br/>
                                <p>Al enviar o cargar cualquier Contenido del usuario, usted le otorga a Alma Lasers y
                                    sus sucesores
                                    y cesionarios una licencia mundial, no exclusiva, libre de regalías, perpetua,
                                    sublicenciable y
                                    transferible en virtud de cualquier derecho de propiedad intelectual, moral o
                                    privacidad para
                                    usar, copiar, distribuir, transmitir, modificar, preparar trabajos derivados de
                                    dicho Contenido
                                    del usuario en relación con los Servicios, inclusive, a modo ilustrativo, para
                                    mejorar los
                                    Servicios. </p>
                                <br/>
                                <h1><u><b>Exenciones de responsabilidad y exclusión de garantías</b></u></h1>
                                <br/>
                                <p>Toda la información y el Contenido publicado a través de los Servicios es solo para
                                    fines
                                    informativos y Alma Lasers no ofrece garantías con respecto a los mismos. Usted
                                    utiliza los
                                    Servicios bajo su propio riesgo y discreción. Los Servicios y el Contenido de los
                                    mismos se
                                    proporcionan TAL CUAL y SEGÚN DISPONIBILIDAD sin garantías de ningún tipo. No
                                    declaramos ni
                                    garantizamos que los Servicios serán de buena calidad o útiles para sus
                                    necesidades. </p>
                                <br/>
                                <p>RECHAZAMOS EXPRESAMENTE TODAS LAS GARANTÍAS DE CUALQUIER TIPO, EXPRESAS, IMPLÍCITAS O
                                    ESTATUTARIAS, RELACIONADAS CON LOS SERVICIOS O EL CONTENIDO DE ESTOS, INCLUIDAS,
                                    ENTRE OTRAS,
                                    LAS GARANTÍAS DE TÍTULO, COMERCIABILIDAD, IDONEIDAD PARA UN PROPÓSITO PARTICULAR, NO
                                    VIOLACIÓN
                                    DE DERECHOS DE PROPIEDAD, NEGOCIACIÓN O RENDIMIENTO. NEGAMOS CUALQUIER GARANTÍA,
                                    EXPRESA O
                                    IMPLÍCITA, (I) CON RESPECTO A LA SEGURIDAD, EXACTITUD, CONFIABILIDAD, PUNTUALIDAD Y
                                    DESEMPEÑO DE
                                    LOS SERVICIOS; (II) CON RESPECTO A LA FALTA DE ERRORES O A LA CORRECCIÓN DE POSIBLES
                                    ERRORES EN
                                    LOS SERVICIOS; O (III) CON RESPECTO AL DESEMPEÑO O LA EXACTITUD, CALIDAD, VIGENCIA,
                                    FINALIZACIÓN
                                    O UTILIDAD DE CUALQUIER INFORMACIÓN PROPORCIONADA POR LOS SERVICIOS. </p>
                                <br/>
                                <p>Ningún consejo o información, ya sea oral o escrita, que obtenga de nosotros creará
                                    una garantía
                                    que no esté expresamente establecida en estos Términos. Si elige confiar en dicha
                                    información,
                                    lo hace bajo su propio riesgo. Algunos estados o jurisdicciones no permiten la
                                    exclusión de
                                    ciertas garantías. En consecuencia, algunas de las exclusiones anteriores pueden no
                                    aplicarse en
                                    su caso. Consulte las leyes locales para conocer las restricciones o limitaciones
                                    relacionadas
                                    con la exclusión de garantías implícitas.</p>
                                <br/>
                                <p>Usted reconoce y acepta que Alma Lasers no es un servicio de retención de datos. Por
                                    lo tanto,
                                    debe crear copias de seguridad de sus datos y Alma Lasers no tendrá ninguna
                                    responsabilidad u
                                    obligación con respecto a cualquier pérdida, daño o corrupción de dichos datos. </p>
                                <br/>
                                <h1><b>Limitación de responsabilidad</b></h1>
                                <br/>
                                <p>Además de lo mencionado, no asumimos ninguna responsabilidad por cualquier error,
                                    omisión,
                                    interrupción, eliminación, defecto, demora en la operación o transmisión, falla de
                                    la línea de
                                    comunicaciones, robo, destrucción, acceso no autorizado o alteración de cualquier
                                    parte del
                                    Contenido o los Servicios. No somos responsables de ningún problema o mal
                                    funcionamiento técnico
                                    de una red o línea telefónica, sistemas o equipos informáticos en línea, servidores
                                    o
                                    proveedores, software, falla de cualquier correo electrónico debido a problemas
                                    técnicos o
                                    congestión de tráfico en Internet o en los Servicios, incluso cualquier lesión o
                                    daño a los
                                    usuarios o al dispositivo móvil o computadora de cualquier persona relacionado con
                                    el uso de los
                                    Servicios. Por ningún motivo seremos responsables de una pérdida o daño, incluidas
                                    las lesiones
                                    personales o la muerte, como consecuencia del uso de los Servicios, de cualquier
                                    contenido
                                    publicado en o a través de los Servicios, o de la conducta de cualquier usuario de
                                    los
                                    Servicios, tanto en línea como sin conexión. Además, no asumimos ninguna
                                    responsabilidad por los
                                    datos incorrectos, incluida la Información personal que usted proporciona o que
                                    recibamos en su
                                    nombre, y por el presente usted declara y garantiza que es el único responsable de
                                    todos los
                                    datos proporcionados a Alma Lasers, incluidos los datos incorrectos, y usted asumirá
                                    toda
                                    responsabilidad por las consecuencias de proporcionarnos dichos datos
                                    incorrectos.</p>
                                <br/>
                                <p>EN NINGÚN CASO NOSOTROS O ALGUNO DE NUESTROS FUNCIONARIOS, DIRECTORES, EMPLEADOS,
                                    CESIONARIOS O
                                    AGENTES SERÁN RESPONSABLES ANTE USTED O CUALQUIER TERCERO POR CUALQUIER DAÑO,
                                    INCLUSO, ENTRE
                                    OTROS, DAÑOS INDIRECTOS, INCIDENTALES, ESPECIALES, PUNITIVOS O CONSECUENTES EN
                                    RELACIÓN CON SU
                                    USO DE LOS SERVICIOS, INCLUIDA, A TÍTULO ENUNCIATIVO, LA CALIDAD, PRECISIÓN O
                                    UTILIDAD DEL
                                    CONTENIDO PROPORCIONADO COMO PARTE DE LOS SERVICIOS, CON INDEPENDENCIA DE LA
                                    PREVISIBILIDAD O NO
                                    DE LOS DAÑOS Y DE SI HEMOS SIDO INFORMADOS ACERCA DE LA POSIBILIDAD DE DICHOS DAÑOS.
                                    LA
                                    LIMITACIÓN DE RESPONSABILIDAD INDICADA SE APLICARÁ EN LA MEDIDA MÁXIMA PERMITIDA POR
                                    LA LEY EN
                                    LA JURISDICCIÓN CORRESPONDIENTE Y EN NINGÚN CASO NUESTRA RESPONSABILIDAD ACUMULADA
                                    HACIA USTED
                                    EXCEDERÁ UN MONTO DE USD 50.</p>
                                <br/>
                                <h1><b>Indemnización y exoneración de responsabilidad</b></h1>
                                <br/>
                                <p>Usted acepta indemnizar, y eximir de responsabilidad a Alma Lasers y sus empleados,
                                    directores,
                                    funcionarios, subcontratistas y agentes, contra todos y cada uno de los reclamos,
                                    daños, costes
                                    o gastos (incluidos los costes judiciales y los honorarios de abogados) que surjan
                                    directamente
                                    o indirectamente debido a lo siguiente: (a) el incumplimiento de estos Términos por
                                    su parte o
                                    cualquier persona que use su computadora o dispositivo móvil y contraseña (ya sea
                                    con o sin
                                    autorización); (b) cualquier reclamo, pérdida o daño experimentado por su uso o
                                    intento de uso
                                    (o incapacidad de uso) de los Servicios; (c) su violación de cualquier ley o
                                    regulación o
                                    cualquiera de sus obligaciones, declaraciones o garantías en virtud del presente;
                                    (d) su
                                    infracción de cualquier derecho de un tercero; y (e) cualquier otro asunto del que
                                    usted sea
                                    responsable en virtud del presente o según la ley aplicable. </p>
                                <br/>
                                <h1><b>Disposiciones varias</b></h1>
                                <br/>
                                <p>Estos Términos se regirán por las leyes del estado de Israel, sin considerar su
                                    elección de
                                    normas legales, y sin tener en cuenta la Convención de las Naciones Unidas sobre la
                                    Venta
                                    Internacional de Mercancías, y los tribunales competentes en Tel Aviv-Yafo tendrán
                                    jurisdicción
                                    exclusiva para escuchar cualquier disputa que surja en virtud de este documento. En
                                    cualquier
                                    acción para exigir el cumplimiento de estos Términos, la parte ganadora tendrá
                                    derecho a recibir
                                    los costes y honorarios de abogados. Cualquier acción contra Alma Lasers debe
                                    iniciarse dentro
                                    de un (1) año a partir de la fecha en que surja el motivo que origina tal acción. En
                                    el caso de
                                    que cualquier disposición de estos Términos se considere inaplicable, dicha
                                    disposición se
                                    reemplazará por una disposición aplicable que cumpla más estrechamente el efecto de
                                    la
                                    disposición original, y los términos restantes de estos Términos permanecerán en
                                    pleno vigor y
                                    efecto. Ningún elemento de estos Términos crea una relación de agencia, empleo,
                                    empresa conjunta
                                    o asociación entre usted y Alma Lasers ni le permite actuar en nombre de Alma
                                    Lasers. Excepto
                                    según se establezca expresamente en estos Términos, estos Términos constituyen el
                                    acuerdo
                                    completo entre nosotros y usted en relación con el objeto del presente, y todos y
                                    cada uno de
                                    los demás acuerdos existentes entre nosotros en relación con los mismos se cancelan.
                                    Podemos
                                    ceder o transferir nuestros derechos y obligaciones en virtud del presente a un
                                    tercero sin
                                    previo aviso. Usted no cederá ni transferirá ninguno de sus derechos u obligaciones
                                    en virtud
                                    del presente, y cualquier cesión que viole lo anterior será nula. Ninguna renuncia a
                                    cualquier
                                    violación o incumplimiento en virtud del presente se considerará como una renuncia a
                                    cualquier
                                    violación o incumplimiento anterior o posterior. Si se nos exige que le enviemos un
                                    aviso en
                                    virtud del presente, podemos proporcionar dicho aviso según los datos de contacto
                                    que
                                    proporcionó al registrarse.</p>
                                <br/>
                                <br/>
                                <i>Última actualización: febrero de 2019</i>


                                {/*
                <br />
                <h1 style={{ textAlign: 'center' }}><u><b>Exhibit A</b></u></h1>
                <br />
                <h1 style={{ textAlign: 'center' }}><b>Data Sharing Addendum</b></h1>
                <br />
                <p>This Data Sharing Addendum ("<b>Addendum</b>"), entered into by and between the entity accepting this DPA ("<b>Customer</b>") and Alma Lasers Ltd. ("<b>Company</b>"), forms an integral part of and is subject to the Terms of Service entered into by and between Customer and Company, ("<b>Terms</b>") and shall be effective as of the date of acceptance by Customer. Capitalized terms not otherwise defined herein shall have the meanings given to them in the Terms.</p>
                <br />
                <p><b>Whereas</b>, each party serves as a Controller (defined below) with respect to Personal Data (defined below) of Customer's Practitioners, Administrators and Patients and;</p>
                <br />
                <p><b>Whereas</b>, the parties wish to set forth the respective responsibilities and duties toward one another and toward Data Subjects (defined below) with respect to their position as co-Controllers of Personal Data; </p>
                <br />
                <p><b>Now therefore</b>, intending to be legally bound, the parties hereby agree as follows:</p>
                <br />
                <p>1) <u><b>Definitions</b></u>. In addition to capitalized terms defined elsewhere in this Addendum, the following terms shall have the meanings set forth below:</p>
                <br />
                <p style={{ marginLeft: '15px' }}>1.1) "<b>Applicable Law</b>" means Regulation 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (General Data Protection Regulation) ("<b>GDPR</b>"), laws implementing or supplementing the GDPR and the relevant laws in the State of Israel.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>1.2) "<b>Controller to Controller Standard Clauses</b>" means the standard clauses for the transfer of Personal Data to Controllers established in third countries approved by the European Commission from time to time, the approved version of which in force at present is that set out in the European Commission's Decision 2004/915/EC of 27 December 2004, available at:<Link to="http://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32004D0915&from=EN"> http://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32004D0915&from=EN</Link> </p>
                <br />
                <p style={{ marginLeft: '15px' }}>1.3) The terms "<b>Controller</b>", "<b>Data Subject</b>", "<b>Personal Data</b>", "<b>Personal Data Breach</b>", "<b>Processor</b>", and "<b>Processing</b>" shall have the meanings ascribed to them in the GDPR.</p>
                <br />
                <h1><u><b>2) Relationship Between the Parties.</b></u></h1>
                <br />
                <p style={{ marginLeft: '15px' }}>2.1) Customer may provide Company with access to Personal Data of its Practitioners, Administrators and/or Patients, in accordance with the Terms and in accordance with and subject to Applicable Law, including, where required, consent from the Practitioner, Administrator or Patient.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>2.2) The parties agree that each will act as a Controller with respect to Personal Data. It is acknowledged that each is a separate, independent Controller of the Personal Data disclosed under the Terms. Personal Data disclosed under the Terms will not be Processed by the parties as joint Controllers as referred to in Article 26 of the GDPR. Each party shall be independently responsible for compliance with its obligations as a Controller under Applicable Law.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>2.3) As the party in contact with the Data Subjects, the Customer shall ensure that Data Subjects are provided with all information required under Applicable Law, including with regard to the source of the Personal Data and how to reach the relevant co-Controller, as required under Applicable Law. </p>
                <br />
                <p style={{ marginLeft: '15px' }}>2.4) The Controller to Controller Standard Clauses shall apply if and to the extent the receiving party Processes the Personal Data in countries outside of the European Economic Area that do not provide an adequate level of data protection. The Controller to Controller Standard Clauses shall be incorporated herein upon execution of this Addendum by the parties. <b>Schedule A</b> to this Addendum shall apply as <u><b>Annex B</b></u> of the Controller to Controller Standard Clauses.</p>
                <br />
                <h1><u><b>3) Processing of Personal Data.</b></u></h1>
                <br />
                <p style={{ marginLeft: '15px' }}>3.1) Neither party will disclose any Personal Data to the other party other than as permitted under the Terms, this Addendum, and under Applicable Law. </p>
                <br />
                <p style={{ marginLeft: '15px' }}>3.2) With respect to Personal Data shared in the context of the Terms, each party shall Process such Personal Data (i) in accordance with the terms of the Terms, this Addendum and Applicable Law and (ii) for the sole purpose of complying with its obligations under the Terms.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>3.3) Each party represents and warrants that it shall only share Personal Data with the other party in compliance with Applicable Law and its obligations under the Terms and this Addendum. Without derogating from the foregoing, Customer represents that it shall not share any Personal Data to Company without obtaining the requisite consent from Data Subjects to share such information.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>3.4) Unless otherwise agreed in writing and in advance, neither party shall share any Personal Data with the other party that contains any Special Categories of Personal Data (in accordance with Article 9 of the GDPR) without having obtained the required consents, or (ii) contains Personal Data relating to children under age 16 or any other age requiring parental consent, as provided by Applicable Law. </p>
                <br />
                <p>4) <u><b>Security</b></u>. Each party shall implement appropriate technical and organizational measures to ensure an appropriate level of security of the Personal Data, including, as appropriate and applicable, the measures referred to in Article 32(1) of the GDPR. </p>
                <br />
                <h1><u><b>5) Personal Data Breach. </b></u></h1>
                <br />
                <p style={{ marginLeft: '15px' }}>5.1) Each party shall notify the other party without undue delay upon becoming aware of a Personal Data Breach. </p>
                <br />
                <p style={{ marginLeft: '15px' }}>5.2) In the event of a Personal Data Breach, the parties shall cooperate in good faith in connection with the investigation, mitigation, and remediation of such Personal Data Breach and for the purpose of complying with each party's obligations under Applicable Law.</p>
                <br />
                <p>6) <u><b>Third Party Processors</b></u>. Each party may transfer Personal Data to and otherwise interact with third-party data Processors. Each party agrees that if it transfers Personal Data or otherwise interacts with a third-party data Processor, it will enter into a separate contractual arrangement with each such Processor to ensure compliance with its obligations under Applicable Law and hereunder. </p>
                <br />
                <h1>7) <b><u>Data Subject Rights.</u></b></h1>
                <br />
                <p style={{ marginLeft: '15px' }}>7.1) Each party shall assist the other party, to the extent reasonably requested, to comply with any of such other party's statutory obligations concerning requests to exercise Data Subject rights under Applicable Law (e.g., for access, rectification, deletion of Personal Data, etc.).</p>
                <br />
                <p style={{ marginLeft: '15px' }}>7.2) When a Data Subject whose Personal Data is being Controlled by both parties submits a written request to either party to inspect his or her Personal Data, such party shall: </p>
                <br />
                <p style={{ marginLeft: '30px' }}>7.2.1) promptly, inform the other party of such request; and [Alma: note this requirement]</p>
                <br />
                <p style={{ marginLeft: '30px' }}>7.2.2) provide the Data Subject with other party's name and address for further inquiries.</p>
                <br />
                <p>8) <u><b>Retention, Deletion or Return of Personal Data</b></u>. Subject to Applicable Law, each party will retain Personal Data only for as long as necessary to satisfy the purposes for which it was provided to such party, or to the extent required by Applicable Law.</p>
                <br />
                <p>9) <u><b>Indemnity</b></u>. Notwithstanding anything to the contrary in the Terms, Customer shall indemnify and hold Company harmless against all claims, actions, third party claims, losses, damages and expenses incurred by Company and arising directly or indirectly out of or in connection with a breach of this Addendum and/or Applicable Law by Customer. </p>
                <br />
                <h1>10) <b><u>General Terms.</u></b></h1>
                <br />
                <p style={{ marginLeft: '15px' }}>10.1) <b>Termination</b>. This Addendum shall terminate automatically upon the termination of the Terms, provided however, that each party's obligations under this Addendum will apply for so long as such party has access to the other party's Personal Data.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>10.2) <b>Governing Law and Jurisdiction.</b></p>
                <br />
                <p style={{ marginLeft: '30px' }}>10.2.1) The parties to this Addendum hereby submit to the choice of jurisdiction stipulated in the Terms with respect to any disputes or claims howsoever arising under this Addendum, including disputes regarding its existence, validity or termination or the consequences of its nullity.</p>
                <br />
                <p style={{ marginLeft: '30px' }}>10.2.2) This Addendum and all non-contractual or other obligations arising out of or in connection with it are governed by the laws of the country or territory stipulated for this purpose in the Terms.</p>
                <br />
                <p style={{ marginLeft: '15px' }}> 10.3) <b>Order of Precedence. </b></p>
                <br />
                <p style={{ marginLeft: '30px' }}>10.3.1) Nothing in this Addendum reduces the parties' obligations under the Terms in relation to the protection of Personal Data or permits either party to Process (or permits the Processing of) Personal Data in a manner that is prohibited by the Terms. </p>
                <br />
                <p style={{ marginLeft: '30px' }}>In the event of inconsistencies between the provisions of this Addendum and any other agreements between the parties, including the Terms and including (except where explicitly agreed otherwise in writing, signed on behalf of the parties) agreements entered into or purported to be entered into after the date of this Addendum, the provisions of this Addendum shall prevail. In the event of inconsistencies between the provisions of this Addendum and the Controller to Controller Standard Clauses, the Controller to Controller Standard Clauses shall prevail.</p>
                <br />
                <h1 style={{ marginLeft: '15px' }}>10.4) <b>Changes in Data Protection Laws.</b></h1>
                <br />
                <p style={{ marginLeft: '30px' }}>10.4.1) Either party may, by at least thirty (30) calendar days' prior written notice to the other party, request in writing any variations to this Addendum if they are required as a result of any change in, or decision of a competent authority under Applicable Law in order to allow Personal Data to be Processed (or continue to be Processed) without breach of Applicable Law.</p>
                <br />
                <p style={{ marginLeft: '30px' }}>10.4.2) If the proposed changes are not acceptable to the other party, the parties shall discuss the issue in good faith in order to reach a solution that is satisfactory to both parties.</p>
                <br />
                <p style={{ marginLeft: '15px' }}>10.5) <b>Severance</b>. Should any provision of this Addendum be held invalid or unenforceable, then the remainder of this Addendum shall remain valid and in force. The invalid or unenforceable provision shall either be (i) amended as necessary to ensure its validity and enforceability, while preserving the parties’ intentions as closely as possible or, if this is not possible, (ii) construed in a manner as if the invalid or unenforceable part had never been contained herein.</p>
                <br />
                <p>This Addendum is entered into and becomes a binding part of the Terms with effect from the date of acceptance hereof. </p> */}

                            </div>
                        }


                    </div>
                    <div className={`alma-box-footer`}>
                        <div className={`alma-danger-button`} onClick={async () => await logoutClickHandler()}>
                            {$t('global.menu.logout')}
                        </div>
                        <div className={`alma-button`} onClick={async () => await agree()}>
                            {$t('global.general.agree')}
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )


}

export default TermsAndConditions;
